module.exports = __webpack_public_path__ + "img/ZJ5274.bda458e3.png";